import axios from 'axios';

const instanceForUpload = axios.create({
  // baseURL: 'http://localhost:8000',
  baseURL: 'https://adminapi.heliumlearn.com/', // Replace with your backend URL
  // baseURL: 'http://52.66.130.46:8000/', // Replace with your backend URL
  headers: {
    'Content-Type': 'application/json', // Adjust the content type as per your backend requirements
  },
});

export default instanceForUpload;